

















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import MessageHelper from "../../helpers/MessageHelper";
import EventApi from "../../api/EventsApi";

@Component({
    components: {},
})

export default class NeedMorePlayersModal extends Vue {
    @Prop({required: true}) private readonly gameName!: string;
    @Prop({required: true}) private readonly playersLeft!: number;
    @Prop({required: true}) private readonly activityId!: number;
    @Prop({required: true}) private readonly contentPackId!: number;

    /**
     * Закрыть модалку
     * @private
     */
    private closeModal(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        MessageHelper.closeNotificationMessage();
        this.$emit('close');
    }

    /**
     * Запустить игру
     */
    private startGame(): void
    {
        const data = {
            contentPackId: this.contentPackId,
            setId: 1,
            activityId: this.activityId,
            newGame: true,
            agreeWithTerms: true,
        };
        MessageHelper.getContentPackTasksMessage(data);
        this.$emit('close');
    }
}
